<div class="fieldset-wrapper" [ngClass]="(questions?.mandatory && isMandatoryUpfront) || (questions?.mandatory && isFormSubmit && questions.isMandatoryInvalid) ? 'isMandatory' : ''">

  <div *ngIf="questions?.QuestionImageAndMedia_1 != null" class="questionImageWrapper" [ngClass]="{'question-border': !isMobile}">
    <app-question-image-and-media [questionImageAndMedias]="questions?.QuestionImageAndMedia_1"
      [imageSize]="questions?.ImageSize" [isMobile]="isMobile">
    </app-question-image-and-media>
  </div>

  <fieldset [attr.aria-required]="isAriaRequired">

    <legend class="question-option-wrapper" [ngClass]="{'question-border': questions.QuestionImageAndMedia_1 == null && !isMobile}">
      <span *ngIf="isPreview && (questions.population_type == 2 || questions.population_type == 5)" class="hidden-question-tooltip-icon" appTooltip [dataContext]="''" [IsButtonPanel]="false" IsAnswerToolTip="true" IsHiddenQToolTip="true">
      </span>
      <span *ngIf="isDisplayQno" class="question-no">{{questions?.qno}}.</span>
      <span *ngIf="questions.piping"
      [ngClass]="{'question-text' : questions?.isOverAllStyleApplied,
      'question-text-nb': !questions?.isOverAllStyleApplied,
      'no-Qno':!isDisplayQno}"
        id="lbltitle_RK{{questions?.UniqueNumber}}"><span
          [innerHTML]="questions?.pipingQuationTitle | headerFooterHtml"></span>
        <span *ngIf="questions.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
          [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0" ></span>
        <div class="constraint-msg-wrapper">
          <div
            [ngClass]="(questions?.isAlertDanger) ? 'q-title-txt inst-txt-style constraint-error-msg': 'q-title-txt inst-txt-style'">
            [{{questions?.error_msg}}]
          </div>
        </div>
      </span>
      <span *ngIf="!questions.piping"
      [ngClass]="{'question-text' : questions?.isOverAllStyleApplied,
      'question-text-nb': !questions?.isOverAllStyleApplied,
      'no-Qno':!isDisplayQno}"
        id="lbltitle_RK{{questions?.UniqueNumber}}"><span [innerHTML]="questions?.qtitle | headerFooterHtml"></span>
        <span *ngIf="questions.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
          [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0" ></span>
        <div *ngIf="questions?.hasMedia && questions?.MediaText != null && questions?.MediaText != ''" class="question-media-text">
          <span>[{{questions?.MediaText}}]</span>
        </div>

        <div class="constraint-msg-wrapper">
          <div
            [ngClass]="(questions?.isAlertDanger) ? 'q-title-txt inst-txt-style constraint-error-msg': 'q-title-txt inst-txt-style'">
            [{{questions?.error_msg}}]
          </div>
        </div>
      </span>
      <span *ngIf="isAriaRequired && isMobile" class="screen-reader-only">This Question is Required</span>
    </legend>

    <div *ngIf="questions?.QuestionImageAndMedia_2 != null" class="questionImageWrapper">
      <app-question-image-and-media [questionImageAndMedias]="questions?.QuestionImageAndMedia_2"
        [imageSize]="questions?.ImageSize" [isMobile]="isMobile">
      </app-question-image-and-media>
    </div>

    <ng-container *ngIf="!isDisplayedPipeMessage;else answerPipeMessage">

    <div class="rank-wrapper">
      <ul class="rank-cont" [attr.constraintLimit]="questions.rank_limit"
        id="ul_Q{{questions?.qno}}_{{questions?.UniqueNumber}}">
        <li id="Rank_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_{{answers.value_id}}_RK"
          class="answer-option rank-option clearfix ui-state-default" *ngFor="let answers of questions.Answers"
          [ngStyle]="{'display': answers?.isHide || answers?.isADLHide ? 'none' :'block'}"
          [hidden]="answers?.isHide || answers?.isADLHide">
          <div class="rank-option-content-with-image">
            <div style="display: table-cell;" class="rankImageCont"
            [ngClass]="imageWidth">
                <!-- [ngClass]="{'oneImageRank': answers.AnswerImages.length == 1, 'twoImageRank': answers.AnswerImages.length == 2}" -->
              <div *ngIf="answers?.AnswerImages || answers?.AnswerMedias" class="clearfix"
                [ngClass]="getAnsImageMediaCSS(answers)"
                style="width: 100%;">
                <div class="rankImage">
                    <app-answer-media [AnswerMedias]="answers?.AnswerMedias"></app-answer-media>
                    <app-answer-images [AnswerImages]="answers?.AnswerImages"></app-answer-images>
              </div>
              </div>
            </div>
            <div id="dv_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RK_{{answers.value_id}}_ID"
              class="rank-option-content clearfix">
              <div class="rank-option-text fl" [innerHTML]="answers.value_text  | headerFooterHtml"></div>
              <div class="rankDropDownCont fr">
                <span class="dropDownArrow">
                  <div class="rank-arrow"></div>
                </span>
                <select id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_RK_{{answers.value_id}}_ID"
                  class="rankDropDown" [attr.value]='answers.value_id' [(ngModel)]="answers.ControlAns" [attr.aria-label]="answers.value_text" >
                  <option *ngFor="let rank of rankArray" [attr.value]="rank">{{rank}}</option>
                </select>
              </div>
              <div class="dv-rank-handle"></div>
            </div>
          </div>
        </li>
      </ul>
      <ng-container *ngIf="isNewParticipation  && (surveyFormat == 1 || surveyFormat == 2)">
        <div  class="ques-response-btn-div">
          <!-- <input type="button" value="{{newParticipationBtnText}}" class="ques-response-btn"
            (click)="gotoNextQuestion(questions,$event.target)" /> -->
            <button *ngIf="isAnsChange" type="button" class="ques-response-btn" (keyup.Space)="gotoNextQuestionKeyboard(questions,$event)" (click)="gotoNextQuestion(questions,$event.target)">{{newParticipationBtnText}}</button>
        </div>
      </ng-container>
    </div>

    </ng-container>
    <ng-template #answerPipeMessage>
      <span [innerHTML]="getAnswerPipeMessage() | headerFooterHtml" class="hidden-message"></span>
    </ng-template>
  </fieldset>
</div>
